import { render, staticRenderFns } from "./ModalAddAdvertisementInfo.vue?vue&type=template&id=2a4f8570&scoped=true&"
import script from "./ModalAddAdvertisementInfo.vue?vue&type=script&lang=js&"
export * from "./ModalAddAdvertisementInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAdvertisementInfo.vue?vue&type=style&index=0&id=2a4f8570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f8570",
  null
  
)

export default component.exports